import * as React from 'react';
import { UIComponentViewImpl } from '../../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState } from '../../../../../toolkit/uicomponent';
import { RepeatCardComponentProps } from './repeatcardcomponent';
import { RepeatCardCSSStyle } from './repeatcardcss';

export class RepeatCardViewImpl extends UIComponentViewImpl<UIDataModel>
{
  
    draw(props: RepeatCardComponentProps, state: UIComponentState, cssStyle: RepeatCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={props.cssStyle.getWrapperCSSStyle()}>
               <label style={props.cssStyle.getLabelCSSStyle(props.isSelected)}>
                    {props.title}
               </label>
            </div>
        );
    }

     
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/viewmodel/repeatcard/repeatcardview.tsx